<ion-header
  class="ion-no-border"
  [class.ion-header-modal-desktop]="platform === PlatformEnum.desktop"
  [class.ion-header-modal-tablet]="platform === PlatformEnum.tablet"
  [class.ion-header-modal-mobile]="platform === PlatformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === PlatformEnum.desktop" slot="end">
      <ion-button
        id="close-modal-button"
        data-cy="simple-action-close-modal-icon"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  data-cy="modal-prompt-area-text"
  [class.ion-content-modal-desktop]="platform === PlatformEnum.desktop"
  [class.ion-content-modal-tablet]="platform === PlatformEnum.tablet"
  [class.ion-content-modal-mobile]="platform === PlatformEnum.mobile"
>
  <div class="content">
    <h3 data-cy="download-order-title-text">
      {{ (title ?? 'i18n.orderPage.downloadOrder') | translate }}
    </h3>
    <form [formGroup]="downloadOrderForm" #form="ngForm">
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-label id="file-name">{{
              'i18n.orderPage.downloadFileName' | translate
            }}</ion-label>
            <ion-input
              id="usf-line-input-style"
              aria-labelledby="file-name"
              label-placement="stacked"
              placeholder="Example Order Name"
              data-cy="download-order-modal-file-name-input"
              formControlName="fileName"
            >
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size-lg="6" size-md="6" size-sm="12" size-xs="12">
            <ion-label
              id="download-format"
              data-cy="download-order-modal-format-label"
            >
              {{ 'i18n.orderPage.downloadFormat' | translate }}
            </ion-label>
            <ion-item data-cy="download-order-modal-format-section">
              <ion-select
                aria-labelledby="download-format"
                [interface]="platform === PlatformEnum.desktop ? 'popover' : ''"
                [interfaceOptions]="
                  platform === PlatformEnum.desktop
                    ? selectPopoverOptions
                    : { mode: 'ios' }
                "
                formControlName="fileType"
                (ionFocus)="isFileTypePopoverOpen = true"
                toggleIcon="chevron-down-outline"
                expandedIcon="chevron-up-outline"
              >
                <ion-select-option
                  *ngFor="let fileType of fileTypes"
                  value="{{ fileType.fileExtension }}"
                  >{{ fileType.fileDisplayTitle ?? fileType.fileExtension }}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col size-lg="6" size-md="6" size-sm="12" size-xs="12">
            <ng-container *ngIf="showOrdersDropdown">
              <ion-label
                id="order-download"
                data-cy="download-order-modal-order-label"
              >
                {{ 'i18n.orderPage.orderDownload' | translate }}
              </ion-label>
              <ion-item data-cy="download-order-modal-order-section">
                <ion-select
                  aria-labelledby="download-order"
                  [interface]="
                    platform === PlatformEnum.desktop ? 'popover' : ''
                  "
                  [interfaceOptions]="
                    platform === PlatformEnum.desktop
                      ? multiSelectPopoverOptions
                      : { mode: 'ios' }
                  "
                  placeholder="Select Orders"
                  (ionFocus)="isOrderDownloadPopoverOpen = true"
                  formControlName="downloadOptions"
                  required="true"
                  [multiple]="true"
                  toggleIcon="chevron-down-outline"
                  expandedIcon="chevron-up-outline"
                >
                  <ion-select-option
                    *ngFor="let order of orders"
                    value="{{ order.orderHeader.orderId }}"
                  >
                    <ng-container
                      *ngIf="
                        !order.orderHeader.tandemOrderNumber;
                        else submittedSelect
                      "
                    >
                      Review Order
                    </ng-container>
                    <ng-template #submittedSelect>
                      {{
                        getOrderStatusTitle(
                          order.orderHeader.orderStatus,
                          order.orderHeader.orderDelivered
                        )
                      }}, Order #{{ order.orderHeader.tandemOrderNumber }}
                    </ng-template>
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ng-container>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === PlatformEnum.desktop"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="no-modal-btn"
        data-cy="download-order-modal-cancel-button"
        [class.usf-outline-green-dsktp-tblt-modal-button]="
          platform === PlatformEnum.desktop || platform === PlatformEnum.tablet
        "
        [class.usf-outline-green-mobile-modal-button]="
          platform === PlatformEnum.mobile
        "
        (click)="dismiss()"
      >
        {{ 'i18n.orderPage.cancel' | translate }}
      </ion-button>
      <ion-button
        id="yes-modal-btn"
        data-cy="download-order-modal-download-button"
        [disabled]="!downloadOrderForm.valid"
        [class.usf-fill-green-dsktp-tblt-modal-button]="
          platform === PlatformEnum.desktop || platform === PlatformEnum.tablet
        "
        [class.usf-fill-green-mobile-modal-button]="
          platform === PlatformEnum.mobile
        "
        (click)="submit()"
      >
        {{ 'i18n.orderPage.download' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
